import { getDiffTime } from '../date';
import { LocalStorage } from '../localStorage';
import {
  DAYS_AFTER_FIRST_PROGRESS_TO_STOP_SHOWING_PRESENTATION_MODAL,
  HOURS_AFTER_FIRST_PROGRESS_TO_SHOW_PRESENTATION_MODAL,
  LOCAL_STORAGE_KEY,
} from './constants';
import { PostgradMicrocertificateStoredInfo } from './interfaces';

export const shouldShowPostgradMicrocertificatePresentationModalToNewUsers = (options: {
  firstContentConsumedDate: Date;
  contractStartDate: Date;
}): boolean => {
  const presentationModalExhibitionStartDateString =
    process.env.VUE_APP_POSTGRAD_MICROCERTIFICATE_PRESENTATION_MODAL_START_DATE;

  if (!presentationModalExhibitionStartDateString) return false;

  const isNewUser =
    options.contractStartDate > new Date(presentationModalExhibitionStartDateString);

  const diffSinceFirstContentConsumedDate = getDiffTime(
    new Date().toJSON(),
    options.firstContentConsumedDate,
  );

  const isBetweenTimeLimitsToShowModal =
    diffSinceFirstContentConsumedDate.hours >=
      HOURS_AFTER_FIRST_PROGRESS_TO_SHOW_PRESENTATION_MODAL &&
    diffSinceFirstContentConsumedDate.days <=
      DAYS_AFTER_FIRST_PROGRESS_TO_STOP_SHOWING_PRESENTATION_MODAL;

  const userHasDismissedModal =
    !!LocalStorage.get<PostgradMicrocertificateStoredInfo>(LOCAL_STORAGE_KEY)
      ?.presentationModalDismissedDate;

  return isNewUser && isBetweenTimeLimitsToShowModal && !userHasDismissedModal;
};

export const storePostgradMicrocertificatePresentationModalViewedDate = () => {
  LocalStorage.set<PostgradMicrocertificateStoredInfo>(LOCAL_STORAGE_KEY, {
    presentationModalDismissedDate: new Date().toJSON(),
  });
};
